import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Department } from '../../../../models';
import {
  WorkflowContextService,
  DataService,
  ClientService
} from '../../../../services';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'wm-client-departments',
  standalone: false,
  templateUrl: './client-department-list.component.html',
  styleUrl: './client-department-list.component.css'
})
export class ClientDepartmentListComponent implements OnInit, OnDestroy {
  departments: Department[] = [];
  clientSub$: Subscription;
  loading = false;

  constructor(
    private _context: WorkflowContextService,
    private _service: DataService,
    private _clientService: ClientService,
    private _router: Router,
    private _toastr: ToastrService
  ) {}

  ngOnDestroy(): void {
    if (this.clientSub$) {
      this.clientSub$.unsubscribe();
    }
  }

  ngOnInit() {
    const load = () => {
      this.loading = true;
      this._clientService
        .getClientDepartments(this._context.client.id, true)
        .subscribe({
          next: departments => {
            this.departments = departments;
            this.loading = false;
          },
          error: error => {
            console.error('Failed to load departments:', error);
            this.departments = [];
            this.loading = false;
          }
        });
    };

    if (this._context.client) {
      load();
    } else {
      this.clientSub$ = this._context.client$.subscribe(() => {
        load();
      });
    }
  }

  deleteDepartment(department: Department) {
    this._clientService.deleteClientDepartment(department.id).subscribe({
      next: success => {
        if (success) {
          const index = this.departments.indexOf(department);
          if (index > -1) {
            this.departments.splice(index, 1);
          }
          this._toastr.success(
            `Department "${department.name}" has been deleted successfully.`
          );
        } else {
          this._toastr.error('Failed to delete department.');
        }
      },
      error: error => {
        console.error('Failed to delete department:', error);
        this._toastr.error('Failed to delete department. Please try again.');
      }
    });
  }

  toggleDepartmentStatus(department: Department) {
    const action = department.isEnabled ? 'disable' : 'enable';
    const serviceCall = department.isEnabled
      ? this._clientService.disableClientDepartment(department.id)
      : this._clientService.enableClientDepartment(department.id);

    serviceCall.subscribe({
      next: success => {
        if (success) {
          // Toggle the local department status instead of replacing with server response
          department.isEnabled = !department.isEnabled;
          this._toastr.success(
            `Department "${department.name}" has been ${action}d successfully.`
          );
        } else {
          this._toastr.error(`Failed to ${action} department.`);
        }
      },
      error: error => {
        console.error(`Failed to ${action} department:`, error);
        this._toastr.error(`Failed to ${action} department. Please try again.`);
      }
    });
  }

  addDepartment() {
    this._router.navigate([
      '/admin/jurisdiction',
      this._context.client.id,
      'settings',
      'departments',
      'add'
    ]);
  }

  editDepartment(department: Department) {
    this._router.navigate([
      '/admin/jurisdiction',
      this._context.client.id,
      'settings',
      'departments',
      department.id
    ]);
  }
}
